let cartKey = "cart-EP";


export const loadCartStateEP = () => {
    try {
        const cartJSON = localStorage.getItem(cartKey);
        if(cartJSON === null) {
            return undefined;
        }
        return JSON.parse(cartJSON);
    }
    catch (error) {
        return undefined;
    }
}

export const loadPortfolioId = () => {
    try {
        const cartJSON = localStorage.getItem("modelPortfolioId");
        if(cartJSON === null) {
            return undefined;
        }
        return JSON.parse(cartJSON);
    }
    catch (error) {
        return undefined;
    }
}

export const loadPortfolioName = () => {
    try {
        const cartJSON = localStorage.getItem("modelPortfolioName");
        if(cartJSON === null) {
            return undefined;
        }
        return JSON.parse(cartJSON);
    }
    catch (error) {
        return undefined;
    }
}
export const loadCurrentState = () => {
    try {
        const cartJSON = localStorage.getItem("current_state");
        if(cartJSON === null) {
            return undefined;
        }
        return JSON.parse(cartJSON);
    }
    catch (error) {
        return undefined;
    }
}


export const saveCartStateEP = (cartState: any) => {
    try {
        let cartJSON = JSON.stringify(cartState);
        localStorage.setItem(cartKey, cartJSON);
    }
    catch (e) {}
}

export const saveCompetitionInLS = (competition: any) => {
    try {
        let competitionId = JSON.stringify(competition);
        localStorage.setItem(cartKey, competitionId);
    }
    catch (e) {}
}


export const saveCompetitionInfoInLS = (origin: any) => {
	try {
		let originData = JSON.stringify(origin);
		localStorage.setItem(cartKey, originData);
	}catch (e) {}
}
